import clsx from "clsx";
import {
    DateFilterValue,
    dateRangeFilterDropdownOptions,
} from "../../constants";
import FormDropdown, { DropdownPosition } from "../FormDropdown";

type DateRangeFilterDropdownProps = {
    value?: DateFilterValue;
    onChange: (value: DateFilterValue) => void;
    selectedTextOverride: string;
    disabledOptions?: DateFilterValue[];
    className?: string;
    inputClassName?: string;
    position?: DropdownPosition;
};

const DateRangeFilterDropdown = ({
    value,
    onChange,
    selectedTextOverride,
    disabledOptions = [],
    className,
    inputClassName,
    position,
}: DateRangeFilterDropdownProps) => {
    const optionsExcludingDisabledOptions =
        dateRangeFilterDropdownOptions.filter(
            (option) => !disabledOptions.includes(option.value)
        );

    return (
        <FormDropdown
            label="Filter by date range"
            hideLabel
            className={clsx("w-full max-w-[15.5rem]", className)}
            options={optionsExcludingDisabledOptions}
            value={value}
            onChange={onChange}
            buildSelectedTextOverride={() => selectedTextOverride}
            inputClassName={clsx("rounded-xl h-12", inputClassName)}
            position={position}
        />
    );
};

export default DateRangeFilterDropdown;
